import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsx("mask", {
        id: "kl5cezqn1__mask0_10120_52177",
        style: {
          maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "30",
        height: "30",
        children: _jsx("path", {
          d: "M15 29.5C6.99187 29.5 0.5 23.0081 0.5 15C0.5 6.99187 6.99187 0.5 15 0.5C23.0081 0.5 29.5 6.99187 29.5 15C29.5 23.0081 23.0081 29.5 15 29.5Z",
          fill: "#C4C4C4",
          stroke: "#152361"
        })
      }), _jsxs("g", {
        mask: "url(#kl5cezqn1__mask0_10120_52177)",
        children: [_jsx("path", {
          d: "M42 0H-4V30H42V0Z",
          fill: "#E30A17"
        }), _jsx("path", {
          d: "M12.2917 22.4998C16.5258 22.4998 19.9583 19.142 19.9583 14.9998C19.9583 10.8577 16.5258 7.49985 12.2917 7.49985C8.05748 7.49985 4.625 10.8577 4.625 14.9998C4.625 19.142 8.05748 22.4998 12.2917 22.4998Z",
          fill: "white"
        }), _jsx("path", {
          d: "M14.2076 21.0003C17.5949 21.0003 20.3409 18.314 20.3409 15.0003C20.3409 11.6865 17.5949 9.00024 14.2076 9.00024C10.8202 9.00024 8.07422 11.6865 8.07422 15.0003C8.07422 18.314 10.8202 21.0003 14.2076 21.0003Z",
          fill: "#E30A17"
        }), _jsx("path", {
          d: "M18.3594 15.0004L25.2939 17.2046L21.0081 11.4339V18.5668L25.2939 12.7962L18.3594 15.0004Z",
          fill: "white"
        }), _jsx("path", {
          d: "M15 29C7.26801 29 1 22.732 1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15C29 22.732 22.732 29 15 29Z",
          stroke: "#152361",
          strokeWidth: "2"
        })]
      })]
    }))
  });
};
export default Component;
